var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item flex-row flex__left margin-bottom-10"},[_c('div',{staticClass:"label font-size__small txt-right"},[_vm._t("label")],2),_vm._v(" "),_c('div',{staticClass:"content width__100 has-border__bottom"},[_vm._t("value")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a564fb6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/adminstration/ketluan/readonly-form-item.vue
// module id = null
// module chunks = 